<select class="form-control" [(ngModel)]="value" (ngModelChange)="onUserChange($event)">
  <option [value]="0">{{ noneText }}</option>
  <option *ngFor="let user of users" [value]="user.UserNum" [selected]="user.UserNum == selectedUserNum ? true : null"
    >{{ user.UserName }}{{ user.Inactive ? ' [' + ('common.inactive' | translate | titlecase) + ']' : '' }}</option
  >
</select>
